import { AnyAction } from 'redux';
import { ActionsObservable, combineEpics, ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax, AjaxError, AjaxResponse } from 'rxjs/ajax';
import { catchError, map, switchMap } from 'rxjs/operators';

import config from '../config';
import { SUBMIT_BILLING, SUCCESS_SUBMIT_BILLING, ERROR_SUBMIT_BILLING } from './actions';

// Reducer
export type BillingState = {
  loading: boolean;
  data: { card: CardInfo };
  error: AjaxError;
};

export type CardInfo = {
  id?: string;
  card_brand?: string;
  last_4?: string;
  exp_month?: number;
  exp_year?: number;
  cardholder_name?: string;
  billing_address?: {
    postal_code?: string;
  };
};

const defaultState: BillingState = {
  loading: false,
  data: {
    card: {},
  },
  error: {} as AjaxError,
};
export const billingReducer = (state = defaultState, action: AnyAction): BillingState => {
  switch (action.type) {
    case SUBMIT_BILLING: {
      return { ...state, loading: true };
    }
    case SUCCESS_SUBMIT_BILLING: {
      const data = action.data;
      return { ...state, data, loading: false };
    }
    default:
      return state;
  }
};

// Epics
const submitBilling$ = (action$: ActionsObservable<AnyAction>) =>
  action$.pipe(
    ofType(SUBMIT_BILLING),
    switchMap((action) => {
      const body = { nonce: action.nonce };
      const headers = { Authorization: `Bearer ${localStorage.getItem('access_token')}` };
      return ajax.post(`${config.apiUrl}/charge`, body, headers);
    }),
    map((res: AjaxResponse) => ({
      type: SUCCESS_SUBMIT_BILLING,
      data: res.response,
    })),
    catchError((error: AjaxError) => of({ type: ERROR_SUBMIT_BILLING, error }))
  );

export const billingEpic = combineEpics(submitBilling$);
